export default __webpack_public_path__ + "static/media/icon-location.57817e6f.svg";